import { Component } from '@angular/core';
import * as firebase from 'firebase';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'JSDashboard';

  constructor(){
    var firebaseConfig = {
      apiKey: "AIzaSyCvsCmWG4qWjrYIdLkEwxE3D2G7br745jo",
      authDomain: "jsdashboard-52839.firebaseapp.com",
      databaseURL: "https://jsdashboard-52839.firebaseio.com",
      projectId: "jsdashboard-52839",
      storageBucket: "jsdashboard-52839.appspot.com",
      messagingSenderId: "468880028762",
      appId: "1:468880028762:web:adb9a55818c2f1356d5463",
      measurementId: "G-8HNPEWMD2M"
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    
  }
}
